import React from 'react';
import { Mic, MicOff, Play, Loader2, FileText, Zap, Volume2 } from 'lucide-react';

const OrderControls = ({
  models,
  selectedModel,
  setSelectedModel,
  selectedLanguage,
  setSelectedLanguage,
  languages,
  listening,
  startRecording,
  stopRecording,
  processOrder,
  generatePDF,
  transcript,
  orderData,
  loading
}) => {
  return (
    <div className="bg-white/5 backdrop-blur-xl rounded-3xl border border-white/10 p-8 mb-8 shadow-2xl">
      <div className="flex flex-wrap items-center justify-between gap-6">
        <div className="flex-1 min-w-80">
          <label className="block text-sm font-semibold text-gray-200 mb-3 uppercase tracking-wider">AI Model Selection</label>
          <div className="relative">
            <select
              value={selectedModel}
              onChange={e => setSelectedModel(e.target.value)}
              className="w-full bg-white/10 backdrop-blur border border-white/20 rounded-2xl px-6 py-4 text-white placeholder-gray-400 focus:ring-2 focus:ring-cyan-400 focus:border-transparent transition-all appearance-none"
            >
              {models.map(model => (
                <option key={model.id} value={model.id} className="bg-gray-900 text-white">{model.id}</option>
              ))}
            </select>
            <Zap className="absolute right-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-cyan-400 pointer-events-none" />
          </div>
        </div>

        <div className="flex-1 min-w-80">
          <label className="block text-sm font-semibold text-gray-200 mb-3 uppercase tracking-wider">Language Selection</label>
          <div className="relative">
            <select
              value={selectedLanguage}
              onChange={e => setSelectedLanguage(e.target.value)}
              className="w-full bg-white/10 backdrop-blur border border-white/20 rounded-2xl px-6 py-4 text-white placeholder-gray-400 focus:ring-2 focus:ring-cyan-400 focus:border-transparent transition-all appearance-none"
            >
              {languages.map(lang => (
                <option key={lang.code} value={lang.code} className="bg-gray-900 text-white">{lang.name}</option>
              ))}
            </select>
            <Volume2 className="absolute right-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-cyan-400 pointer-events-none" />
          </div>
        </div>

        <div className="flex gap-4">
          <button
            onClick={listening ? stopRecording : startRecording}
            className={`group flex items-center gap-3 px-8 py-4 rounded-2xl font-semibold transition-all transform hover:scale-105 active:scale-95 shadow-lg ${
              listening 
                ? 'bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white shadow-red-500/25' 
                : 'bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white shadow-cyan-500/25'
            }`}
          >
            <div className={`p-1 rounded-full ${listening ? 'bg-white/20' : 'bg-white/20'}`}>
              {listening ? <MicOff className="w-5 h-5" /> : <Mic className="w-5 h-5" />}
            </div>
            {listening ? "Stop Recording" : "Take Order"}
            {listening && <div className="w-2 h-2 bg-white rounded-full animate-ping"></div>}
          </button>

          <button
            onClick={processOrder}
            disabled={!transcript || !selectedModel || loading}
            className="group flex items-center gap-3 px-8 py-4 rounded-2xl font-semibold bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all transform hover:scale-105 active:scale-95 shadow-lg shadow-purple-500/25"
          >
            <div className="p-1 rounded-full bg-white/20">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Play className="w-5 h-5" />}
            </div>
            {loading ? "Processing..." : "Process Order"}
          </button>

          <button
            onClick={generatePDF}
            disabled={!orderData || loading}
            className="group flex items-center gap-3 px-8 py-4 rounded-2xl font-semibold bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white disabled:opacity-50 disabled:cursor-not-allowed transition-all transform hover:scale-105 active:scale-95 shadow-lg shadow-green-500/25"
          >
            <div className="p-1 rounded-full bg-white/20">
              <FileText className="w-5 h-5" />
            </div>
            Send to Kitchen
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderControls; 